import { render, staticRenderFns } from "./cancelamentos.vue?vue&type=template&id=5fbec196"
import script from "./cancelamentos.vue?vue&type=script&lang=js"
export * from "./cancelamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports